import axios from 'axios';
import authHeader from './auth-header';
import BasicService from './basic.service'

class ManageChannelsService extends BasicService {
    getChannels() {
        return this.checkError(axios.get(this.getApiUrl(true) + 'manageChannels/getChannels', { headers: authHeader() }));
    }
    
    getSingleChannel(id) {
        return this.checkError(axios.post(this.getApiUrl(true) + 'manageChannels/getSingleChannel', {id: id}, { headers: authHeader() }));
    }
    
    saveChannel(channel) {
        return this.checkError(axios.post(this.getApiUrl(true) + 'manageChannels/saveChannel', {
            cid: channel.cid,
            name: channel.name,
            topic: channel.topic,
            description: channel.description,
            deletePassword: (channel.deletePassword ? true : null),
            password: (channel.password ? channel.password : null),
            maxClients: channel.maxClients,
        },{ headers: authHeader() }));
    }

    addSubChannel(channel) {
        return this.checkError(axios.post(this.getApiUrl(true) + 'manageChannels/addSubChannel', {
            pid: channel.pid,
            name: channel.name,
            topic: channel.topic,
            description: channel.description,
            password: (channel.password ? channel.password : null),
            maxClients: channel.maxClients,
        },{ headers: authHeader() }));
    }

    deleteSubChannel(cid) {
        return this.checkError(axios.post(this.getApiUrl(true) + 'manageChannels/delSubChannel', { cid: cid }, { headers: authHeader() }));
    }

    getOnlineClients() {
        return this.checkError(axios.get(this.getApiUrl(true) + 'manageChannels/getOnlineClients', { headers: authHeader() }));
    }

    createMeeting(selected, cid) {
        return this.checkError(axios.post(this.getApiUrl(true) + 'manageChannels/createMeeting', { selected: selected, cid: cid }, { headers: authHeader() }));
    }

    deleteClientChannelGroup(cid, cgid, dbid) {
        return this.checkError(axios.post(this.getApiUrl(true) + 'manageChannels/delClientChannelGroup', { cid: cid, cgid: cgid, dbid: dbid }, { headers: authHeader() }));
    }

    addClientChannelGroup(cid, cgid, dbid) {
        return this.checkError(axios.post(this.getApiUrl(true) + 'manageChannels/addClientChannelGroup', { cid: cid, cgid: cgid, dbid: dbid }, { headers: authHeader() }));
    }

    movedSubChannel(pid, order) {
        return this.checkError(axios.post(this.getApiUrl(true) + 'manageChannels/movedSubChannel', { pid: pid, order: order }, { headers: authHeader() }));
    }
}

export default new ManageChannelsService();